import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { CurrencyDisplayUtil } from './../../common/currency-display-util';
import { AppConfig } from './../../app.config';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { IntradayLadderService } from './intraday-ladder.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { createSerialChart } from '../../dashboard/dashboard-graphical-chart-generator';
import * as moment from 'moment';

@Component({
    selector: 'app-intraday-ladder',
    templateUrl: './intraday-ladder.component.html',
    styleUrls: ['./intraday-ladder.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IntradayLadderComponent implements OnInit {
    breakdownType = 'expectedactual';
    tableData;
    columns: any[];
    constructor(
        private intradayLadderService: IntradayLadderService,
        private amChartsService: AmChartsService,
        private appConfig: AppConfig
    ) { }

    ngOnInit() {
        this.refreshData('USD');
    }

    refreshData(currency: string) {
        const operatingDate = this.appConfig.getTodayString();
        const startHour = this.appConfig.activeUserProfile.getUserStartTimeHour();
        const endHour = this.appConfig.activeUserProfile.getUserEndTimeHour();
        const startOfWorkDay = moment(operatingDate).startOf('day').add(startHour, 'hours');
        const endOfWorkDay = moment(operatingDate).startOf('day').add(endHour, 'hours');

        this.columns = [
        ];
        let hour = startHour;
        while (hour <= endHour) {
            const paddedHour = this.padHour(hour);
            this.columns.push({
                field: paddedHour,
                header: paddedHour
            })
            hour++;
        }
        this.intradayLadderService.getIntradayTimeBucketedPositions(currency, startOfWorkDay, endOfWorkDay)
            .then((result: any) => {
                const currentHour = moment().hour();
                const chartData = result.byTime
                    .map((row) => {
                        if (row.hour >= currentHour) {
                            row.actual = undefined;
                        }
                        row.displayTime = row.time.clone().local().format('HH-00');
                        return row;
                    })
                    .filter((row) => {
                        return row.time.isBetween(startOfWorkDay, endOfWorkDay, null, '[]');
                    })
                    .sort((r1, r2) => {
                        return (r1.time < r2.time) ? -1 : 1;
                    });
                // this.amChartsService.makeChart('intradayladderchartdiv', {
                //     'type': 'serial',
                //     'hideCredits': true,
                //     'theme': 'light',
                //     'dataProvider': chartData,
                // }
                createSerialChart(this.amChartsService, 'intradayladderchartdiv', 'line', false, false,
                    chartData, 'displayTime', ['expected', 'actual']);


                const groupedByAccount = result.byAccount.reduce((grouped, data) => {
                    const key = data.account;
                    grouped[key] = grouped[key] || [];
                    grouped[key].push(data);
                    return grouped;
                }, {});
                const accountRows = Object.keys(groupedByAccount)
                    .map((account: string) => {
                        const accountRow: any = {};
                        accountRow.account = account;
                        groupedByAccount[account].forEach((row) => {
                            row.displayTime = row.time.clone().local().format('HH-00');
                            accountRow[row.displayTime] = [CurrencyDisplayUtil.toShortNumber(row.expected, 1),
                            CurrencyDisplayUtil.toShortNumber(row.actual, 1)];
                            if (row.expected) {
                                accountRow[row.displayTime + '_percent'] = row.actual / row.expected;
                            }
                            // accountRow
                        })
                        return accountRow;
                    })
                this.tableData = accountRows;
            });
    }

    padHour(n: number): string {
        const nStr = n + '';
        const padded = '00'.substring(0, 2 - nStr.length) + nStr + '-00';
        return padded;
    }

    onBreakDownTypeClicked(event: MatButtonToggleChange) {
        this.breakdownType = event.value;
    }

    expectedValue(data: any[]) {
        if (data) {
            return data[0];
        }
        return null;
    }

    actualValue(data: any[]) {
        if (data) {
            return data[1];
        }
        return null;
    }

    getHeatColor(percent: number) {
        if (!percent) {
            return 'grey';
        }
        if (percent < 0.25) {
            return 'red';
        } else if (percent < 0.75) {
            return 'yellow'
        } else if (percent <= 1.1) {
            return 'green'
        } else {
            return 'purple';
        }
    }
}
